<template>
  <div class="about container">
    <section class="container-flex">
      <h1> About Marc Wilk </h1>
      <div class="img-container">
        <progressive-img :src="marc" title="Marc" alt="Marc Wilk Self Photo">
          </progressive-img>
      </div>
      <div class="copy" v-html="about">

      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import marc from '../assets/marcwilk.jpg';
import placeholder from '../assets/placeholder.png';

export default {
  data() {
    return {
      marc,
      placeholder,
      about: JSON.parse(localStorage.getItem('about')),
    };
  },
  mounted() {
    const currentDate = Math.round(new Date().getTime());
    const date = localStorage.getItem('aboutDate');
    if (!date || date < currentDate) {
      const spreadsheetID = '1yU1wlobATjM5Nut4gMj_Gf3OfrB5e_keH4Cab5X8N4I';
      const url = `https://docs.google.com/spreadsheets/d/${spreadsheetID}/gviz/tq?tqx=out:json`;
      axios.get(url).then((response) => {
        const r = response.data.match(/google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/);
        if (r && r.length == 2) {
          const table = JSON.parse(r[1]).table;
          const rows = table.rows.map(({c}) => c.map(({v}) => v));
          this.about = rows[1][0];
          localStorage.setItem('about', JSON.stringify(this.about));
          localStorage.setItem('aboutDate', Math.round(new Date().getTime() + (24 * 3600)));
        }
      });
    }
  },
};

</script>

<style lang="scss" scoped>
  h1 {
    width: 100%;
  }
  .copy {
    width: 100%;
    @include respond-to(medium) {
      width: 50%;
    }
  }
  .img-container {
    width: 100%;
    @include respond-to(medium) {
      width: 40%;
      margin: 0 spacing(base) 0 0;
      max-width: 350px;
    }
  }
</style>
